import { CdkScrollableModule } from '@angular/cdk/scrolling';
import { NgModule } from '@angular/core';

import {
  CosDrawerComponent,
  CosDrawerContainerComponent,
  CosDrawerContentComponent,
} from './drawer';

@NgModule({
  imports: [
    CdkScrollableModule,
    CosDrawerComponent,
    CosDrawerContainerComponent,
    CosDrawerContentComponent,
  ],
  exports: [
    CdkScrollableModule,
    CosDrawerComponent,
    CosDrawerContainerComponent,
    CosDrawerContentComponent,
  ],
})
export class CosDrawerModule {}
